<template>
  <div class="diceBg" :class="{'part': $route.meta.text == '파트너 페이지'}">
    <div class="diceBgDark dice">
      <main-header v-if="$route.name !== 'partnerCashList' && $route.name !== 'partnerBettingList' && $route.name !== 'partnerList' && $route.name !== 'partnerCalculationList' && $route.name !== 'partnerCalculationUserList' && $route.name !== 'partnerMemberList' && $route.name !== 'partnerMoneyMoveList'" :selectedMenu="selectedMenu" />
      <div class="content0" :class="{'sub': $route.name !== 'main'}">
        <router-view :key="$route.fullPath"></router-view>
        <main-footer v-if="banner" />
      </div>
    </div>
  </div>

  <slot-list v-if="isSlotOpen" :groupCode="groupCode" :codeName="codeName" :code="code" @isSlot="isSlotOpen = false"></slot-list>
  <loading></loading>
</template>

<script>
import MainHeader from './Header'
import MainFooter from './Footer'
import SlotList from '@/components/game/SlotList'
import { mapState } from 'vuex'
import Loading from '@/components/common/Loading.vue'

export default {
  name: 'DefaultLayout',
  components: {
    Loading,
    SlotList,
    MainHeader,
    MainFooter
  },
  computed: {
    ...mapState([
      'banner'
    ])
  },
  mounted () {
    this.emitter.on('isSlot', (data) => {
      if (data) {
        const groupCode = data.groupCode
        const codeName = data.codeName
        const code = data.code
        this.getSlotOpen(groupCode, codeName, code)
      } else {
        this.isSlotOpen = false
      }
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeMount () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  data () {
    return {
      isSlotOpen: false,
      groupCode: '',
      codeName: '',
      code: '',
      isLoading: false,
      selectedMenu: ''
    }
  },
  methods: {
    scrollToSection (menu) {
      const sectionId = menu.replace(/ /g, '')
      const sectionElement = document.getElementById(sectionId)
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll () {
      const sectionElements = document.querySelectorAll('section')
      const selectedSection = Array.from(sectionElements).find((section) => {
        const rect = section.getBoundingClientRect()
        return rect.top <= 0 && rect.bottom > 0
      })
      if (selectedSection) {
        this.selectedMenu = selectedSection.id
      }
    },
    getSlotOpen (groupCode, codeName, code) {
      if (this.userData) {
        this.groupCode = groupCode
        this.codeName = codeName
        this.code = code
        this.isSlotOpen = true
      } else {
        this.onCheck('front.error.afterSignin')
      }
    }
  }
}
</script>

<style>
/* .diceBg {background: url(../assets/img/main_bgobj.png) repeat; background-size: 10%;} */
.diceBg {min-height: 100vh;background: #070711;}
.diceBgDark {width: 100%; min-height: 100vh;}
.fade-enter {
  opacity: 0;
}

.fade-enter-active {
  transition: opacity 0.5s ease-in;
}

.fade-leave-active {
  transition: opacity 0.2s ease-in;
}

.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}

.slide-up-enter {
  transform: translateY(185px);
  opacity: 0;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-leave-to {
  transform: translateY(0px);
  opacity: 0;
}
.part {background: #fff;}
.sub {
  position: relative;
  width: min(100%, 1260px);
  margin: 0 auto;
  box-sizing: border-box;
  overflow-x: clip;
  min-height: 100vh;
  background:
    radial-gradient(circle at 18% 14%, rgba(244, 63, 158, .16), transparent 25%),
    radial-gradient(circle at 82% 28%, rgba(139, 92, 246, .14), transparent 30%),
    radial-gradient(circle at 62% 78%, rgba(236, 72, 153, .08), transparent 26%),
    repeating-radial-gradient(circle at 50% 0, rgba(255,255,255,.045) 0 1px, transparent 1px 34px),
    linear-gradient(145deg, #070711 0%, #110817 48%, #080914 100%);
  background-attachment: fixed;
}
.sub .w1260 {width: 100%;max-width: 1260px;}
</style>
